var _process$env$NODE_ENV, _process$env$VERCEL_E;

// types
// export
var nodeEnv = (_process$env$NODE_ENV = process.env.NODE_ENV) != null ? _process$env$NODE_ENV : 'development';
var vercelEnv = (_process$env$VERCEL_E = process.env.VERCEL_ENV) != null ? _process$env$VERCEL_E : 'development';
var isDev = nodeEnv === 'development';
var isTest = nodeEnv === 'test';
var isStaging = nodeEnv === 'staging';
var isProd = nodeEnv === 'production';
var isServer = typeof window === 'undefined';
var isClient = typeof window !== 'undefined';
var isVercelDev = vercelEnv === 'development';
var isVercelPreview = vercelEnv === 'preview';
var isVercelProd = vercelEnv === 'production';

exports.isClient = isClient;
exports.isDev = isDev;
exports.isProd = isProd;
exports.isServer = isServer;
exports.isStaging = isStaging;
exports.isTest = isTest;
exports.isVercelDev = isVercelDev;
exports.isVercelPreview = isVercelPreview;
exports.isVercelProd = isVercelProd;
exports.nodeEnv = nodeEnv;
exports.vercelEnv = vercelEnv;
//# sourceMappingURL=index.js.map
